/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type CreateProjectMutationInput = {
    readonly installDate?: string | null;
    readonly name: string;
    readonly purchaserId?: string | null;
    readonly shippingAddress?: AddressInput | null;
    readonly userId: string;
    readonly clientMutationId?: string | null;
};
export type AddressInput = {
    readonly active?: unknown | null;
    readonly contact?: string | null;
    readonly city?: string | null;
    readonly company?: string | null;
    readonly country?: string | null;
    readonly firstName?: string | null;
    readonly lastName?: string | null;
    readonly label?: string | null;
    readonly line1?: string | null;
    readonly line2?: string | null;
    readonly phoneNumber?: string | null;
    readonly state?: string | null;
    readonly zipCode?: string | null;
};
export type createProjectMutationVariables = {
    readonly input: CreateProjectMutationInput;
};
export type createProjectMutationResponse = {
    readonly createProject: {
        readonly project: {
            readonly serviceId: string | null;
            readonly createdDate: string | null;
            readonly name: string | null;
            readonly portfolio: {
                readonly serviceId: string | null;
            } | null;
        } | null;
    } | null;
};
export type createProjectMutation = {
    readonly response: createProjectMutationResponse;
    readonly variables: createProjectMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "CreateProjectMutationInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "createdDate",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "name",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "createProjectMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "createProject",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CreateProjectMutationPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "project",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Project",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "portfolio",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PortfolioV2",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "createProjectMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "createProject",
                    "storageKey": null,
                    "args": (v1 /*: any*/),
                    "concreteType": "CreateProjectMutationPayload",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "project",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Project",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "portfolio",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "PortfolioV2",
                                    "plural": false,
                                    "selections": [
                                        (v2 /*: any*/),
                                        (v5 /*: any*/)
                                    ]
                                },
                                (v5 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "mutation",
            "name": "createProjectMutation",
            "id": "app-buyer-misc/230.0.0-2019-08-28T11:54:11.732Z/createProjectMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'f7eb86f9af6b59958827eb9b812282a2';
export default node;
